import React from 'react';
function PrintRapportAdmin() {
    return ( <>
    <h1>C'est un rapport </h1>
    </> );
}

export default PrintRapportAdmin;